"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/builtin/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Portal.default;
  }
});

var _Portal = _interopRequireDefault(require("./Portal"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/Portal/index.js
// module id = 145
// module chunks = 0